/**
 * The list picker's ranks for a group on all lists (19/10/2026): "#1 —
 * today's best", "#2" … up to the group's limit. A drop tied to a rank
 * follows the group every day; today's list shows next to each rank.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Check, Hash } from 'lucide-react';

interface Props {
  groupName: string;
  /** How many ranks to offer (the group's "up to"). */
  count: number;
  /** Today's lists, best first (from the plan); missing = not known yet. */
  today: string[];
  rank?: number;
  onRank: (rank: number) => void;
}

export const SlotRankOptions: FC<Props> = ({ groupName, count, today, rank, onRank }) => (
  <div className="border-t border-border/60 pt-1">
    <p className="px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      By rank — follows {groupName} every day
    </p>
    {Array.from({ length: count }, (_, i) => i + 1).map((k) => (
      <button
        key={k}
        type="button"
        role="option"
        aria-selected={rank === k}
        aria-label={`Rank #${k} of ${groupName}`}
        onClick={() => onRank(k)}
        className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-xs hover:bg-accent"
      >
        <Hash className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden />
        <span className="w-14 shrink-0 font-medium">#{k}{k === 1 ? ' best' : ''}</span>
        <span className="min-w-0 flex-1 truncate text-muted-foreground">{today[k - 1] ? `today: ${today[k - 1]}` : today.length ? 'no list today' : ''}</span>
        {rank === k ? <Check className="h-3.5 w-3.5 text-primary" /> : null}
      </button>
    ))}
  </div>
);
